import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('stash');
export default logger;
